<template>
  <div class="page-wrapper">
    <div :class="['header-wrap style1', { sticky: isSticky }]">
      <div class="header-top">
        <div class="container">
          <TopHeader />
        </div>
      </div>
      <MainNavbarPages />
    </div>

    <div class="content-wrapper">
      <!-- <PageBanner pageTitle="Service Details" mainTitle="Service Details" /> -->
      <div class="service-details-wrap ptb-50">
        <div class="container">
          <div class="row">
            <div class="col-xl-4 col-lg-12 order-xl-1 order-lg-2 order-md-2 order-2">
              <SideBar />
            </div>

            <div class="col-xl-8 col-lg-12 order-xl-2 order-lg-1 order-md-1 order-1">
              <div class="service-desc">

                <div class="row">
                  <div class="col-md-9">
                    <h2>Dr. Alexandra Veronica Menghereș – Medic specialist reumatolog</h2>
                    <div class="other-option md-none mt-40">
                      <a href="/#appointment" class="btn style2">
                        Solicită o programare
                      </a>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="team-card style3">
                      <div class="team-img">
                        <img src="../../../assets/images/doctors/dr-alexandra-veronica-mengheres.jpg"
                          alt="Dr. Alexandra Veronica Menghereș – Reumatologie" />
                      </div>
                    </div>
                  </div>
                </div>

                <p>
                  Sunt <strong>Dr. Alexandra Veronica Menghereș</strong>, medic specialist reumatolog.
                  Prețuiesc prezența fiecărui pacient care calcă pragul cabinetului meu și îmi doresc să 
                  contribui la îmbunătățirea stării de sănătate și a calității vieții lor de zi cu zi, 
                  în măsura puterilor mele și prin decizii luate de comun acord cu fiecare în parte.
                </p>

                <h3>Competențe profesionale</h3>
                <ul class="content-feature-list style5 list-style">
                  <li>
                    <i class="ri-check-double-line"></i>Diagnosticul și managementul bolilor imun-inflamatorii reumatismale (Spondilartrite, Artrită reumatoidă, Lupus eritematos sistemic, Miozite)
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>Diagnosticul și managementul bolilor degenerative și mecanice osteo-articulare (artroze, discopatii)
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>Diagnosticul și managementul bolilor metabolice (Artropatii microcristaline – gută, condrocalcinoză; Osteoporoză)
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>Patologie abarticulară (tendinite, bursite)
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>Infiltrații intraarticulare / periarticulare
                  </li>
                </ul>

                <h3>Educație și formare profesională</h3>
                <p>
                  Pregătirea profesională este fundamentul practicii medicale moderne,
                  motiv pentru care formarea continuă ocupă un rol esențial în activitatea
                  mea medicală.
                </p>

                <ul class="content-feature-list style5 list-style">
                  <li>
                    <i class="ri-check-double-line"></i>
                    2016 – 2025 – Rezidențiat în cadrul Spitalului Clinic de Recuperare Iași, secția Reumatologie I
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>
                    2010 – 2016 – Facultatea de Medicină Generală în cadrul Universității de Medicină și Farmacie „Gr. T. Popa”, Iași
                  </li>
                </ul>

              </div>
            </div>

          </div>
        </div>
      </div>

    </div>
    <MainFooter />
  </div>
</template>

<script>
import TopHeader from "../../Layouts/TopHeader.vue";
import MainNavbarPages from "../../Layouts/MainNavbarPages.vue";
import SideBar from "./SideBar.vue";
import MainFooter from "../../Layouts/MainFooter.vue";

import { defineComponent } from "vue";

export default defineComponent({
  name: "AlexandraMengheresPage",
  components: {
    TopHeader,
    SideBar,
    MainNavbarPages,
    MainFooter,
  },
  data() {
    return {
      isSticky: false,
    };
  },
  mounted() {
    window.addEventListener("scroll", () => {
      let scrollPos = window.scrollY;
      if (scrollPos >= 100) {
        this.isSticky = true;
      } else {
        this.isSticky = false;
      }
    });
  },
});
</script>